module.exports = __webpack_public_path__ + "media/application/images/2018/2018-rating-lock-black-5666a6b867b4e2099c90d733e0e79a3e.svg";